import { Button } from '@krp/ui-kit'

import { nextStep, type NextStepVm } from '../model/tabs'
import type { EquipmentSnapshot, VerdictState } from '../model/types'
import { verdict, type VerdictLineVm } from '../model/verdict'

const TONE: Record<VerdictState, 'ok' | 'warn' | 'block' | 'wait'> = {
  ready: 'ok',
  warn: 'warn',
  blocked: 'block',
  'not-configured': 'wait',
  unknown: 'wait',
  waiting: 'wait',
}

function Line({ line }: { line: VerdictLineVm }) {
  return (
    <li className={`hw-verdict__line hw-box hw-box--${TONE[line.state]}`}>
      <strong>{line.title}:</strong>{' '}
      <span>
        <span aria-hidden="true">{line.glyph}</span> {line.word}
        {line.reason !== null && line.reason.length > 0 ? `: ${line.reason}` : ''}
      </span>
    </li>
  )
}

/**
 * Вердикт «могу ли я продавать» двумя строками и одна главная кнопка «Дальше: …» (п. 2.4).
 * Пока не проверено — слово «не проверялось», а не «готов».
 */
export function Verdict({ snapshot, onNext }: { snapshot: EquipmentSnapshot; onNext: (step: NextStepVm) => void }) {
  const vm = verdict(snapshot)
  const step = nextStep(snapshot)
  return (
    <section aria-label="Можно ли продавать" className="hw-verdict">
      <ul className="hw-verdict__lines">
        <Line line={vm.cash} />
        <Line line={vm.card} />
      </ul>
      {step !== null && (
        <Button variant="primary" actionId="platform.hardware.next-step" onClick={() => onNext(step)}>
          {step.text}
        </Button>
      )}
    </section>
  )
}
